import React from 'react';
import { FaFilm, FaLayerGroup, FaUsers, FaCheckCircle, FaTimesCircle, FaClock } from 'react-icons/fa';

const ProjectsKpiGrid = ({ dashboardStats }) => {
  const items = [
    { title: "Total Projects", value: dashboardStats.totalProjects, icon: <FaFilm />, trend: "Live Projects" },
    { title: "Total Roles", value: dashboardStats.totalRoles, icon: <FaLayerGroup />, trend: "Active" },
    { title: "Total Auditions", value: dashboardStats.totalAuditions, icon: <FaUsers />, trend: "Applications" },
    { title: "Selected", value: dashboardStats.selected, icon: <FaCheckCircle />, trend: "Selected" },
    { title: "Rejected", value: dashboardStats.rejected, icon: <FaTimesCircle />, trend: "Rejected" },
    { title: "Pending", value: dashboardStats.pending, icon: <FaClock />, trend: "Waiting" }
  ];

  return (
    <div className="roles-kpi-grid">
      {items.map((item, index) => (
        <div className="roles-kpi-card" key={index}>
          <div className="roles-kpi-top">
            <div className="roles-kpi-icon">{item.icon}</div>
            <div className="roles-kpi-trend">{item.trend}</div>
          </div>
          <div className="roles-kpi-bottom">
            <p className="roles-kpi-label">{item.title}</p>
            <h3 className="roles-kpi-value">{item.value}</h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectsKpiGrid;
